export default __webpack_public_path__ + "static/media/cleanpro-comingsoon-bear-logo.99c71161.png";